module.exports = __webpack_public_path__ + "img/bdsh_1.cc9c0e1a.png";